export default __webpack_public_path__ + "media/images/icons/pix-a392d0ef0d465fcbef6c25a8b7d2d370.svg";